import {
  Configuration,
  DefaultApi as MamiClient,
} from '@peartherapeutics/mami-client';
import { getConfig } from 'utils/config';
import { sessionGet, SessionKeys } from 'utils/tokenStorage';

let mamiClientPromise: Promise<MamiClient>;

export const getMamiClient = async (token?: string) => {
  const { MAMI_URL } = await getConfig();

  // Caches mami client for subsequent calls.
  if (!mamiClientPromise) {
    const mamiClient = new MamiClient(
      new Configuration({
        basePath: `${MAMI_URL}/api`,
        accessToken: `JWT ${token || sessionGet(SessionKeys.AUTH_TOKEN)}`,
      }),
    );

    mamiClientPromise = Promise.resolve(mamiClient);
  }

  return mamiClientPromise;
};
